/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Box } from '@atlaskit/primitives/compiled';
import { CommentAction } from '@atlaskit/comment';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useHideSave } from './utils.tsx';

const HideAction = () => {
	const { formatMessage } = useIntl();
	const {
		canEdit,
		isInternal,
		isIssueOfIncidentsPractice,
		jsdIncidentActivityViewHidden,
		isSaving,
	} = useCommentContext();
	const onHideSave = useHideSave();
	if (!canEdit || !isInternal || !isIssueOfIncidentsPractice) {
		return null;
	}
	return (
		<Box testId="issue-comment-base.ui.comment.custom-comment.hide-action">
			<CommentAction key="hide" onClick={onHideSave} isDisabled={isSaving}>
				{formatMessage(jsdIncidentActivityViewHidden ? messages.unhide : messages.hide)}
			</CommentAction>
		</Box>
	);
};
export default HideAction;
